import styled from "styled-components";

export const MainHeader = styled.header`
    font-size: 40px;
    font-weight: bold;
    margin-bottom: 25px;
`